import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RemarkItem } from "../../../types/models/ucux.model";
import { useState } from "react";

// 
// Redux Slice Configuration
// 

interface State {
  remarks: RemarkItem[];
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  remarks: [],
  loading: false,
  error: null,
};

// GET: Fetch all remarks for a record
export const fetchRemarks = createAsyncThunk<
  RemarkItem[],
  { recordId: string }
>("ucux/fetchRemarks", async ({ recordId }) => {
  const res = await fetch(`/aprs/ucux/record/${recordId}/detail`);
  if (!res.ok) throw new Error("Failed to fetch remarks");
  const data = await res.json();
  return data.remark ?? [];
});

export const ucuxRemarksSlice = createSlice({
  name: "ucuxRemarks",
  initialState,
  reducers: {
    clearRemarks(state) {
      state.remarks = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRemarks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRemarks.fulfilled, (state, action) => {
        state.loading = false;
        state.remarks = action.payload;
      })
      .addCase(fetchRemarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch remarks";
      });
  },
});

export const { clearRemarks } = ucuxRemarksSlice.actions;
export default ucuxRemarksSlice.reducer;

// 
// Custom Hook Controller (Toast logic)
//  

export const useUcuxRemarksController = () => {
  const [showSuccessToast, setShowSuccessToast] = useState<boolean>(false);
  const [successToastMessage, setSuccessToastMessage] = useState<string>("");

  const showSuccessToastNotification = (message: string) => {
    setSuccessToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => {
      setShowSuccessToast(false);
    }, 3000);
  };

  return {
    toast: {
      showSuccessToast,
      successToastMessage,
      showSuccessToastNotification,
    },
  };
};
